const V1 = "/api/v1";

export const ENDPOINTS = {

  AUTH: {
    ADMIN_LOGIN: `${V1}/auth/admin-login`,
    SELLER_LOGIN: `${V1}/auth/seller-login`,
    SELLER_REGISTER: `${V1}/auth/seller-register`,
    BUYER_LOGIN: `${V1}/auth/buyer-login`,
    BUYER_REGISTER: `${V1}/auth/buyer-register`,
    LOGOUT: `${V1}/auth/logout`,
    GET_ME: `${V1}/auth/me`,

    SEND_OTP: `${V1}/otp/send`,
    VERIFY_OTP: `${V1}/otp/verify`
  },
  PASSWORD: {
    FORGOT_PASSWORD: `${V1}/password/forgot-password`,
    RESET_PASSWORD: `${V1}/password/reset-password`
  },

  INDUSTRY_GROUPS: {
    CREATE: `${V1}/industry-groups`,
    SEARCH: `${V1}/industry-groups/search`,
    BY_ID: (id) => `${V1}/industry-groups/${id}`,
    UPDATE: (id) => `${V1}/industry-groups/${id}`,
    DELETE: (id) => `${V1}/industry-groups/${id}`
  },

  MAIN_CATEGORIES: {
    CREATE: `${V1}/main-categories`,
    SEARCH: `${V1}/main-categories/search`,
    BY_ID: (id) => `${V1}/main-categories/${id}`,
    UPDATE: (id) => `${V1}/main-categories/${id}`,
    DELETE: (id) => `${V1}/main-categories/${id}`,
    INDUSTRY_GROUP_DROPDOWN: `${V1}/main-categories/industry-group-dropdown`
  },

  FAMILIES: {
    CREATE: `${V1}/families`,
    SEARCH: `${V1}/families/search`,
    BY_ID: (id) => `${V1}/families/${id}`,
    UPDATE: (id) => `${V1}/families/${id}`,
    DELETE: (id) => `${V1}/families/${id}`,
    MAIN_CATEGORY_DROPDOWN: `${V1}/families/main-category-dropdown`
  },

  PRODUCTS: {
    CREATE: `${V1}/products`,
    SEARCH: `${V1}/products/search`,
    BY_ID: (id) => `${V1}/products/${id}`,
    UPDATE: (id) => `${V1}/products/${id}`,
    DELETE: (id) => `${V1}/products/${id}`,
    FAMILY_DROPDOWN: `${V1}/products/family-dropdown`
  },

  SPEC_TYPES: {
    CREATE: `${V1}/spec-types`,
    SEARCH: `${V1}/spec-types/search`,
    BY_ID: (id) => `${V1}/spec-types/${id}`,
    UPDATE: (id) => `${V1}/spec-types/${id}`,
    DELETE: (id) => `${V1}/spec-types/${id}`,
    FAMILY_DROPDOWN: `${V1}/spec-types/family-dropdown`
  },

  SPEC_VALUES: {
    BASE: `${V1}/spec-values`,
    SEARCH: `${V1}/spec-values/search`,
    BY_ID: (id) => `${V1}/spec-values/${id}`,
    SPEC_TYPE_DROPDOWN: `${V1}/spec-values/spec-type-dropdown`
  },

  BUYERS:{

    SEARCH:`${V1}/buyers/search`,
    BY_ID:(id)=>`${V1}/buyers/${id}`,

    VERIFY:(id)=>`${V1}/buyers/${id}/verify`,
    UNVERIFY:(id)=>`${V1}/buyers/${id}/unverify`,

    ACTIVATE:(id)=>`${V1}/buyers/${id}/activate`,
    DEACTIVATE:(id)=>`${V1}/buyers/${id}/deactivate`

    },

  SELLERS:{

    SEARCH:`${V1}/sellers/search`,
    BY_ID:(id)=>`${V1}/sellers/${id}`,

    VERIFY:(id)=>`${V1}/sellers/${id}/verify`,
    UNVERIFY:(id)=>`${V1}/sellers/${id}/unverify`,

    ACTIVATE:(id)=>`${V1}/sellers/${id}/activate`,
    DEACTIVATE:(id)=>`${V1}/sellers/${id}/deactivate`

    },

    LISTED_PRODUCTS:{

    SEARCH:`${V1}/listed-products/search`,

    CREATE:`${V1}/listed-products`,

    BY_ID:(id)=>`${V1}/listed-products/${id}`,

    VERIFY:(id)=>`${V1}/listed-products/verify/${id}`,

    DELETE:(id)=>`${V1}/listed-products/${id}`

},




ADMIN_OVERVIEW:{
  DASHBOARD:`${V1}/admin/overview`
},

 /* OVERVIEW */
  SELLER_OVERVIEW:{
    DASHBOARD: `${V1}/seller/overview`
  },

  /* PRODUCTS */
  SELLER_PRODUCTS: {
    PRODUCTS_SEARCH: `${V1}/seller/products/search`,
    PRODUCTS_CREATE: `${V1}/seller/products`,
    PRODUCTS_DELETE: (id) => `${V1}/seller/products/${id}`,

    /* NEW */
    PRODUCT_SPECS: (product_id) => `${V1}/seller/products/specs/${product_id}`,
    PRODUCT_BY_ID: (id) => `${V1}/seller/products/${id}`,
    PRODUCT_UPDATE: (id) => `${V1}/seller/products/${id}`,

    MASTER_PRODUCT_SPECS: (id) =>
  `${V1}/seller/master-product/specs/${id}`,
  },
  

  /* RFQs */
  RFQS: {
    RFQ_SEARCH: `${V1}/seller/rfqs/search`,
    RFQ_APPROVE: (id) => `${V1}/seller/rfqs/${id}/approve`,
    RFQ_REJECT: (id) => `${V1}/seller/rfqs/${id}/reject`,
  },
  

  /* PROFILE */
  SELLER_PROFILE:{
    PROFILE_GET: `${V1}/seller/profile`,
    PROFILE_UPDATE: `${V1}/seller/profile`,
  },

  /* ANALYTICS */
  SELLER_ANALYTICS: {
    ANALYTICS: `${V1}/seller/analytics`
  },

  BUYER_OVERVIEW:{
  DASHBOARD: `${V1}/buyer/overview`
  },

  BUYER_RFQS:{
    CREATE: `${V1}/buyer/rfqs`,
    SEARCH: `${V1}/buyer/rfqs/search`
  },

  BUYER_PRODUCTS:{
    SEARCH: `${V1}/buyer/products/search`,
    FILTERS: `${V1}/filters`,
    BY_ID: (id)=>`${V1}/buyer/products/${id}`
  },

  BUYER_SAVED:{
    SAVE: `${V1}/buyer/save-product`,
    LIST: `${V1}/buyer/save-product`,
    DELETE: (id)=>`${V1}/buyer/save-product/${id}`
  },

  BUYER_PROFILE:{
    GET: `${V1}/buyer/profile`,
    UPDATE: `${V1}/buyer/profile`
  },

  BUYER_REVIEWS:{
  ADD: `${V1}/buyer/reviews`,
  LIST: (id) => `${V1}/buyer/reviews/${id}`
},



MASTER_PRODUCTS: {

  CREATE: `${V1}/master-products`,

  LIST: `${V1}/master-products/list`,

  BY_ID: (id) => 
    `${V1}/master-products/${id}`,

  UPDATE: (id) => 
    `${V1}/master-products/${id}`,

  DELETE: (id) => 
    `${V1}/master-products/${id}`,

  GET_SPECS: (product_id) => 
    `${V1}/master-products/specs/${product_id}`,

  GET_MASTER_SPECS: (id) =>
    `${V1}/master-products/spec-values/${id}`

}

};